import { useContext } from 'react';

import { GroupContext } from './GroupContext';

export const useGroup = () => {
  return useContext(GroupContext);
};
